import React from "react";
import { Card } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Games from "../Pages/Parts/Home/Games";

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            search: null
        }
    }

    componentDidMount() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    change = (e) => {
        let value = e.target.value;
        this.setState({ search: value });
    }

    render() {
        return <>
            <Helmet>
                <title>Original Games </title>
            </Helmet>
            <div>
                <Card className="brd7">
                    <Card.Body className="py-2">
                        <div id="st">
                            <h4 className="mt-2 mb-2 section-title"> Original Games</h4>
                            <Games />
                        </div>
                    </Card.Body>
                </Card>
            </div>
        </>
    }
}

export default Index;
